import Vue from 'vue';
import App from './app.vue';
import iView from 'iview';
import locale from 'iview/dist/locale/vi-VN';
import { router } from './router/index';

import 'famfamfam-flags/dist/sprite/famfamfam-flags.css';
import './theme.less';
import Ajax from './lib/ajax';
import Util from './lib/util';
import SignalRAspNetCoreHelper from './lib/SignalRAspNetCoreHelper';
import _ from 'lodash';
import VueLazyload from 'vue-lazyload';
import moment from 'vue-moment';
Vue.use(require('vue-moment'));
Vue.use(iView, { locale: locale, transfer: true });
// or with options
Vue.use(VueLazyload, {
	preLoad: 1.3,
	error: '',
	loading: '',
	attempt: 1,
});
import store from './store/index';
Vue.config.productionTip = false;
import { appRouters, otherRouters } from './router/router';
if (!abp.utils.getCookieValue('Abp.Localization.CultureName')) {
	let language = navigator.language;
	abp.utils.setCookieValue(
		'Abp.Localization.CultureName',
		language,
		new Date(new Date().getTime() + 5 * 365 * 86400000),
		abp.appPath
	);
}

Ajax.get('/AbpUserConfiguration/GetAll').then((data) => {
	Util.abp = Util.extend(true, Util.abp, data.data.result);
	new Vue({
		render: (h) => h(App),
		router: router,
		store: store,
		data: {
			currentPageName: '',
		},
		async mounted() {
			this.currentPageName = this.$route.name as string;
		},
		created() {
			let tagsList: Array<any> = [];
			appRouters.map((item) => {
				if (item.children.length <= 1) {
					tagsList.push(item.children[0]);
					if (!Util.isNull(item.children[0].children) && item.children[0].children.length > 0) {
						item.children[0].children.forEach((element) => {
							if (Util.isNull(element.children) || element.children.length <= 1) {
								tagsList.push(element);
							} else {
								tagsList.push(...element.children);
							}
						});
					}
				} else {
					tagsList.push(...item.children);
				}
			});
			this.$store.commit('app/setTagsList', tagsList);
		},
	}).$mount('#app');
});
